import { lazy } from 'react';

export const AuthContainerAsync = lazy(() => import('./AuthContainer').then((m) => ({ default: m.AuthContainer })));
